module.exports = __webpack_public_path__ + "img/addIcon.ce481e0a.svg";